import React from "react";
import PageTitle from "../components/PageTitle";

const PrivacyPolicy = () => {
  PageTitle(
    "Privacy policy - Right Cash - We Buy, We Sell, Buybacks, Pawnbrokers. Get Cash Fast - Chatham, Kent - Pawn Shop"
  );
  return (
    <div className="privacy-policy">
      <h1>Right Cash Privacy Policy</h1>
      <h2>Right Cash Ltd Privacy Policy</h2>

      <p>
        We are a Consumer Credit Business licensed body the FCA Ref number{" "}
        <strong>619665</strong>.<br />
        We are registered with the ICO for Data Protection ref number{" "}
        <strong>A8269497</strong>.
      </p>
      <p>
        We do not require a Data Protection Officer because we are a small
        business with relatively small amounts of data stored. The key contact
        for data protection is Managing Director, Right Cash, Unit 2 Lakeview
        Stables, Lower St Clere, Sevenoaks, Kent, TN15 6NL Under FCA SYSC
        requirements we have a senior manager who takes responsibility for data,
        their title is Managing Director.
      </p>

      <h3>Who’s the Data Controller?</h3>
      <p>
        For the purposes of data protection laws, Right Cash ltd is the “data
        controller” of all personal information that is collected, used and/or
        otherwise processed under this Privacy Policy.
      </p>

      <h3>Why are you collecting my information?</h3>
      <p>
        Any information you provide us, either using the internet, in-store or
        by any other means, is only collected for purposes which are reasonably
        necessary for, or directly related to, one or more of our business
        functions, products or activities. Products that require the collection
        of information include Pawnbroking loans, Buyback, Buys and Laybys.
        Please note that third party’ brokers provide their own specific privacy
        notices.
      </p>
      <p>These purposes include using and processing your information:</p>
      <ul>
        <li>
          To provide you with the products and services they request and to
          monitor, evaluate and improve products and services;
        </li>
        <li>
          To assist you with queries, resolve your complaints, or requests for
          access to information, or to manage any legal action involving us;
        </li>
        <li>
          to manage customer relationships or accounts and perform other
          administrative and operational tasks (including risk management,
          systems development and testing, credit scoring, identity
          verification, staff training, collecting debts and market or customer
          satisfaction research);
        </li>
        <li>To comply with legal obligations.</li>
        <li>to the extent otherwise permitted by law</li>
        <li>
          to gather and aggregate information for statistical, prudential,
          actuarial and research purposes;
        </li>
        <li>
          to develop and implement measures to detect or prevent unlawful
          activity, fraud, money laundering and credit loss; and any or all of
          these processes may be automated
        </li>
      </ul>
      <p>
        We may transfer your data if our business is reorganized or sold. Your
        refusal to provide data may prevent us from delivering services. We do
        not share data unless required or permitted by law.
      </p>

      <h3>What data do you collect?</h3>
      <p>
        We retain data and relevant information about our customers on the
        following basis;
      </p>

      <h3>Pawnbroking / Purchases / Buybacks – </h3>
      <p>
        Legitimate Interest- We process – proof of name, address complying with
        AML requirements. We ask for I.D [eg passport or driving license/
        utility bill] for all new customers and apply due diligence as per our
        AML policy.
      </p>
      <h3>Pawnbroking-Marketing soft opt in - </h3>
      <p>
        {" "}
        We use a soft opt in for marketing. This means that unless the customer
        ticks the box on contract note 6 of their Pawn Contract we may send them
        relevant marketing e mails and contact them as per article 22 of the
        PECR (Privacy and Electronic Communications Regulations), on the basis
        that; ∙ we have obtained the contact details in the course of a pawn
        contract ∙ we are only marketing their own similar products or services;
        and ∙ we gave the person a simple opportunity to refuse or opt out of
        the marketing, both when first collecting the details and in every
        message after that.
      </p>
      <h3>Website</h3>
      <p>
        If you visit our website to read, browse or download information, our
        system may record the following information which is provided by your
        browser:
      </p>
      <ul>
        <li>the date and time of your visit;</li>
        <li>the type of browser and operating system you are using;</li>
        <li>
          standard internet and website log information to understand our
          website visitors use;
        </li>
        <li>
          your Internet Service Provider and top-level domain name (for example
          – .com, .gov, .au, .uk etc);
        </li>
        <li>
          the address of any referring web site (for example – the previous web
          site you visited) and the website you visit after leaving our site;
          and
        </li>
        <li>
          your computer’s IP (Internet Protocol) address (a number which is
          unique to the machine through which you are connected to the
          internet).
        </li>
      </ul>
      <p>
        Website data is kept strictly confidential. It is used for internal
        research purposes and to provide goods and services that you request. It
        helps us monitor which sections of the site are most popular to give us
        a clear idea of what type of information and services to include on our
        site. It also informs us which members and subscribers are using the
        site so that we can customise the website information and presentation.
      </p>
      <p>
        When you use one of our web sites, we may send you a “cookie” that gives
        you a unique identification number. A “cookie” is a packet of
        information that allows the server (the computer that houses the
        website) to identify and interact more effectively with your computer. A
        different identification number is sent each time you use one of our
        websites. These cookies may be Session cookies which only last until you
        close your browser, or they may be Persistent cookies which are stored
        longer term on your computer. Cookies do not identify individual users,
        although they may identify a user’s browser type and your Internet
        Service Provider (ISP).
      </p>
      <p>
        You can configure your browser to accept all cookies, reject all
        cookies, or notify you when a cookie is sent. Please refer to your
        browser instructions or help screens to learn more about these
        functions. If you reject all cookies, you may not be able to use our
        websites or certain website functions may not work properly or at all.
      </p>
      <h3>Collection via Email</h3>
      <p>
        If you decide to complete an online form, we will collect the
        information that you enter into the online form and the IP address of
        your computer. If you cancel your application prior to submission, any
        information entered on the current screen which has not yet been
        submitted, will be automatically deleted. Information you have already
        submitted to us prior to you cancelling your application may be used to
        contact you about your application, after which it will be automatically
        deleted. The deletion referred to above will happen within a reasonable
        period of time but in any event, no longer than 30 business days.{" "}
      </p>

      <h3>Other Activities</h3>
      <p>
        [For marketing through third parties and for CRAs (Credit Rating
        Assessments) we specifically request Consent of the customer, and they
        must opt in by signing our privacy statement ]
      </p>
      <h3>CCTV</h3>
      <p>
        is retained as part of the legitimate process of preventing crime.
        Footage is shared with the relevant authorities on request to help
        ongoing investigations
      </p>
      <p>
        Every customer is able to view privacy notice before any pawn or buyback
        transaction via a printed privacy notice on the Counter or on a
        contract. Since the basis for processing data is Legitimate Interest ( a
        pawn contract) the customer is not required to sign this.
      </p>
      <strong>
        <p>
          Every contract has a Data Processing Clause (no. 6 on back of pawn
          contract)
        </p>
      </strong>
      <p>
        This is a shortened version of the privacy notice but also has a soft
        opt in for marketing.
      </p>
      <h3>Your Rights</h3>
      <p>
        You may request details of personal information which we hold about you
        under the GDPR at any time (a Data Subject Access Request or DSAR). No
        fee will be required, although reasonable fees can be charged for
        manifestly unfounded or excessive requests. Your request will be
        responded to within one calendar month or any earlier time limit
        prescribed by law.
      </p>
      <p>You have the following rights:</p>
      <ul>
        <li>
          to make changes or corrections to your information to make sure it is
          accurate and up to date;
        </li>
        <li>
          ask us to stop or limit our use or processing of your information or
          delete your information (we are not obliged to do this in relation to
          information we need as part of our contractual relationship or for
          compliance with other laws, such as taxation or accounting laws);
        </li>
        <li>receive a copy of the information we hold about you;</li>
        <li>withdraw consent you have previously provided;</li>
        <li>transfer your information to a third party; and</li>
        <li>
          the right to lodge a complaint about us to the UK Information
          Commissioner’s Office (https://ico.org.uk/) or the relevant authority
          in your country of work or residence.
        </li>
      </ul>
      <p>
        Please note that we reserve the right to retain certain information for
        our own record-keeping (for example, to ensure that you do not receive
        marketing communications that you have opted-out of receiving) and to
        defend ourselves against any claims. We may also need to send you
        service-related communications relating to the goods or services that we
        provide to you even when you have requested not to receive marketing
        communications.
      </p>

      <p>
        You can exercise these rights by contacting us using the contact
        information on this Privacy Policy. Please be aware that we may need you
        to provide additional information in order to process your request, such
        as to confirm your identity and/or to confirm what information you wish
        to access.
      </p>
      <h3>Acceptance and Changes to Privacy Policy</h3>
      <p>
        You acknowledge and accept that your use of Right Cash ltd’s website or
        of products which direct you to this Privacy Policy indicates your
        acceptance of our website terms of use and of the use and disclosure of
        information provided for under this Privacy Policy. This is the current
        Privacy Policy. If we make changes to this Privacy Policy, we will
        revise the “Last Updated” date on the final page of this Privacy Policy.
        You accept that by doing this we have provided you with sufficient
        notice of any variation.If we make any changes that we think are
        material in the way we collect, use, and/or share your Personal
        Information, we will notify you by sending an email to the email address
        you most recently provided us in your account or registration (unless we
        do not have such an email address We recommend that you check our
        website from time to time to inform yourself of any changes in this
        Privacy Policy or any of our other policies.
      </p>

      <h3>Contact Information</h3>
      <p>
        If you have question, want to exercise your rights or make a complaint,
        please contact us
      </p>
      <p>
        If we cannot resolve your complaint, you may contact the Financial
        Ombudsman Service at:
      </p>
      <p>
        Financial Ombudsman Service,
        <br /> <br />
        Exchange Tower,
        <br /> <br />
        London,
        <br /> <br />
        E14 9SR, <br />
        <br />
        Tel: 08000 234 567.
        <br /> <br />
        You also have the right to complain to the Information Commissioner’s
        Office at
        <br /> <br />
        Wycliffe House,
        <br /> <br />
        Water Lane,
        <br /> <br />
        Wilmslow,
        <br /> <br />
        Cheshire,
        <br /> <br />
        SK9 5AF.
        <br /> <br />
        www.ico.org.uk.
        <br /> <br />
        We may contact you by post, email, SMS or telephone for the purposes of
        marketing our products and services; please tick the box in note 6 / 8
        on your contract if you do not wish to receive such marketing.
        <br />
      </p>

      {/* Inline simple CSS */}
      <style>{`
        .privacy-policy {
            max-width: 900px;
            margin: 2rem auto;
            padding: 2rem;
            font-family: Arial, sans-serif;
            line-height: 1.6;
            background: #fdfdfd;
            border: 1px solid #ddd;
            border-radius: 8px;
          }
          
          .privacy-policy h1 {
            font-size: 2rem;
            margin-bottom: 1rem;
            color: #333;
          }
          
          .privacy-policy h2 {
            font-size: 1.5rem;
            color: #444;
            margin-bottom: 1rem;
          }
          
          .privacy-policy h3 {
            font-size: 1.2rem;
            margin-top: 1.5rem;
            color: #555;
          }
          
          .privacy-policy p {
            margin-bottom: 1rem;
            color: #444;
          }
          
          .privacy-policy ul {
            margin-left: 1.5rem;
            list-style-type: disc;
          }
          
          .privacy-policy li {
            margin-bottom: 0.5rem;
          }
          
          .privacy-policy a {
            color: #0066cc;
            text-decoration: none;
          }
          
          .privacy-policy a:hover {
            text-decoration: underline;
          }
          
      `}</style>
    </div>
  );
};

export default PrivacyPolicy;
